import { createBrowserHistory } from 'history';

export default createBrowserHistory({basename: 'Motile-Website', forceRefresh: true});